export default function Toast({ type, message }) {
  const color = type === "success" ? "green" : "red";
  return (
    <div className={`fixed top-5 right-5 bg-${color}-100 border border-${color}-300 text-${color}-800 px-4 py-2 rounded shadow z-50`}>
      {type === "success" ? "✅" : "❌"} {message}
    </div>
  );
}
